module.exports = __webpack_public_path__ + "static/media/security_icon.950149c6.png";